import { UserData } from 'models';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateAchievements } from 'redux/reducers/achievements';
import { RootState } from 'redux/store';
import api, { VoteApiResponse, VOTE_API_ACTION_TYPE } from 'util/api';

export const CATEGORIES = {
  VIDEOS: 'cat01',
  EXHIBIT: 'cat02',
  CHAT: 'cat03',
  SURVEY: 'cat04',
};

export default function useAchievements(fetchAchievements = false) {
  const { total, categories } = useSelector((state: RootState) => state.achievements);
  const userData: UserData | null = useSelector((state: RootState) => state.user.data);
  const cms = useSelector((state: RootState) => state.widget.cms);
  const { apiKey, version_id: versionId } = cms.settings;
  const { code, token } = userData || {};

  const dispatch = useDispatch();

  const submitAchievement = useCallback(
    async (category: string, contestant: string) => {
      const payload = {
        apiKey,
        timestamp: Date.now(),
        action_type: VOTE_API_ACTION_TYPE.SUBMIT_STAR,
        token,
        code,
        category,
        contestant,
      };

      const res: VoteApiResponse = await api.postToVoteApi(payload, null, versionId);
      dispatch(updateAchievements(res));
    },
    [apiKey, token, code, versionId, dispatch]
  );

  useEffect(() => {
    async function getAchievements() {
      const payload = {
        apiKey,
        timestamp: Date.now(),
        action_type: VOTE_API_ACTION_TYPE.GET_SURVEY,
        token,
        code,
      };

      const res: VoteApiResponse = await api.postToVoteApi(payload, null, versionId);
      dispatch(updateAchievements(res));
    }

    if (fetchAchievements) {
      getAchievements();
    }
  }, [apiKey, code, dispatch, fetchAchievements, token, versionId]);

  return {
    total,
    categories,
    submitAchievement,
  };
}
